<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/yr/nbanner.png" alt="">
        </div>
        <div class="main">
            <div class="nav">
                <span @click="goto(0)">Home /</span>
                <span @click="goto(1)">News /</span>
                <span >{{info.TITLE}} /</span>
            </div>
            <p class="title">{{info.TITLE}}</p>
            <p class="time">{{info.SHOWTIME}}</p>
            <div class="htmlCon" v-html="info.CONTENT">

            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import {getNewsInfo} from '../util/lang'
    export default {
        name: "blogInfo",
        data(){
            return{
                info:{}
            }
        },
        components:{footComponent},
        mounted(){
            this.getNewsInfo(this.$route.query.id)
        },
        methods:{
            goto(n){
                if(n===0){
                    this.$router.push({path:'/'})
                }else{
                    this.$router.push({path:'/news'})
                }
            },
            getNewsInfo(id){
                this.$nextTick(()=>{
                    const url = `${getNewsInfo(this.$i18n.locale,id)}`
                    this.$axios.get(url).then(res => {
                        res.data.SHOWTIME=res.data.SHOWTIME.substring(0,11)
                        this.info=res.data
                    })
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    animation: down 2s linear;
    @keyframes down {
        from{
            transform: translateX(-30px);
        }
        to{
            transform: translateX(0);
        }
    }
    .banner{
        width:100%;
        overflow: hidden;
        img{
            width:100%;
            object-fit: cover;
            display: block;
            animation: big 1s linear forwards;
        }
        @keyframes big {
            from{
                transform: scale(1.1);
            }
            to{
                transform: scale(1);
            }
        }
    }
    .main{
        width:1280px;
       margin: 0 auto;
        line-height: 30px;
        padding-bottom: 60px;
        .nav{
            width:100%;
            margin: 30px 0;
            span{
                text-transform: uppercase;
                padding-right: 5px;
                cursor: pointer;
                font-family: Calibri;
            }
            span:last-child{
                color:#F4A000;
            }
        }
        p{
            width:100%;
            text-align: center;
        }
        .title{
            font-size: 35px;
            font-weight: bolder;
        }
        .time{
            font-size: 14px;
            font-family: Calibri;
            font-weight: lighter;
            padding-bottom: 10px;
            border-bottom: 1px solid rgba(0,0,0,.5);
        }
        .htmlCon{
            width:100%;
            background-color: #fafafa;
        }
    }
    @media screen and (max-width:450px) {
        .banner {
            img {
                height: 300px;
            }
        }
        .main{
            width:90%;
            margin-left: 5%;
            .title{
                font-size: 18px;
            }
        }
    }
}
</style>
<style scoped>
    @media screen and (max-width:450px){
        .htmlCon >>> p img{
            width:100%;
            object-fit: cover;
        }
    }

</style>
